import { keepPreviousData, useQuery } from '@tanstack/react-query'
import {
  getPortalActualVsBudget,
  getPortalFinancialsTable,
} from '@/services/portal.service'
import type { CompanyFinancialsScenarioType } from '@/services/companies.service'
import type { CompanyFinancialsTrailingPeriod } from '@/services/companies.service'
import { portalKeys } from '@/hooks/use-portal'

type BaseFinancialsParams = {
  scenarioType: CompanyFinancialsScenarioType
  trailingPeriod: CompanyFinancialsTrailingPeriod
  showBlankPeriods: boolean
  asOfDate?: string
}

type FinancialsParams =
  | (BaseFinancialsParams & { view: 'MONTHLY'; months?: number })
  | (BaseFinancialsParams & { view: 'QUARTERLY'; quarters?: number })
  | (BaseFinancialsParams & { view: 'ANNUAL'; years?: number })

export function usePortalFinancialsTable(params: FinancialsParams) {
  return useQuery({
    queryKey: portalKeys.financials(params),
    queryFn: () => getPortalFinancialsTable(params),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
  })
}

export function usePortalActualVsBudget() {
  return useQuery({
    queryKey: [...portalKeys.all, 'actual-vs-budget'],
    queryFn: getPortalActualVsBudget,
    staleTime: 5 * 60 * 1000,
  })
}
